import axios from "axios";
import { environment } from "../api/environment";

axios.defaults.baseURL = ( environment.env == 'development' ? '/dev/json' :  environment.END_POINT_URL )